import React from 'react';
import '../svg.css';


const F_A_Additions = props => {
    const { fill } = props;
    return (
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"
            height="36px"
            width="36px"
            className='svg'
        >
            <g id="Logo"><rect id="frame" className="f-a-additions-1" width="36" height="36" rx="10" /></g><g className="f-a-additions-2"><path className="f-a-additions-3" d="M24.72,16.77V15.09l-2-.32a4.45,4.45,0,0,0-.55-1.33l1.17-1.66-1.19-1.19-1.64,1.18a4.88,4.88,0,0,0-1.33-.56l-.35-2H17.15l-.33,2a4.51,4.51,0,0,0-1.34.55l-1.63-1.17-1.19,1.19,1.15,1.64a4.81,4.81,0,0,0-.56,1.34l-2,.33v1.68l2,.35a5,5,0,0,0,.56,1.35L12.64,20.1l1.19,1.19,1.65-1.16a4.81,4.81,0,0,0,1.34.56l.33,2h1.68l.35-2a4.88,4.88,0,0,0,1.33-.56l1.66,1.17,1.19-1.19-1.19-1.65a4.35,4.35,0,0,0,.55-1.33ZM18,18.29A2.35,2.35,0,1,1,20.34,16,2.34,2.34,0,0,1,18,18.29Z" /></g><path className="f-a-additions-3" d="M25.45,22v2.71a.68.68,0,0,1-.68.67H11.23a.68.68,0,0,1-.68-.67V22H9.2v2.71a2,2,0,0,0,2,2H24.77a2,2,0,0,0,2-2V22Z" />        </svg>
    );
};

export default F_A_Additions;
